import {
  ViveApiBaseService,
  ViveApiRequestOptions
} from './vive-api-base.service';
import {
  CompanyExpiringInsuranceResponseDto,
  CompanyReviewProgressCountsResponseDto,
  CompanyVendorsAccountingAlertsResponseDto,
  CompanyVendorsActivityResponseDto,
  CompanyVendorsActivitySummaryResponseDto,
  CompanyVendorsSpotlightResponseDto,
  CompanyVendorsStatusCountsResponseDto,
  CompanyVendorsTradeCountsResponseDto,
  ContractsSummaryResponseDto
} from './vive-api-models';

class ClientDashboardService extends ViveApiBaseService {
  public async getReviewProgressCounts(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<CompanyReviewProgressCountsResponseDto> {
    const { options, pathParams } = params;
    return await this.sendGet<CompanyReviewProgressCountsResponseDto>({
      apiEndpoint: 'companies/:companyId/review-progress-counts',
      options,
      pathParams
    });
  }

  public async getVendorStatusCounts(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<CompanyVendorsStatusCountsResponseDto> {
    const { options, pathParams } = params;
    return await this.sendGet<CompanyVendorsStatusCountsResponseDto>({
      apiEndpoint: 'companies/:companyId/vendor-status-counts',
      options,
      pathParams
    });
  }

  public async getAccountingAlerts(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<CompanyVendorsAccountingAlertsResponseDto> {
    const { options, pathParams } = params;
    return await this.sendGet<CompanyVendorsAccountingAlertsResponseDto>({
      apiEndpoint: 'companies/:companyId/accounting-alerts',
      options,
      pathParams
    });
  }

  public async getVendorActivitySummary(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
    queryParams?: { days?: number };
  }): Promise<CompanyVendorsActivitySummaryResponseDto> {
    const { options, pathParams, queryParams } = params;
    return await this.sendGet<CompanyVendorsActivitySummaryResponseDto>({
      apiEndpoint: 'companies/:companyId/vendor-activity/summary',
      options,
      pathParams,
      queryParams
    });
  }

  public async getVendorActivity(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
    queryParams?: {
      days?: number;
      page?: number;
      pageSize?: number;
      includeCount?: boolean;
    };
  }): Promise<CompanyVendorsActivityResponseDto> {
    const { options, pathParams, queryParams } = params;
    return await this.sendGet<CompanyVendorsActivityResponseDto>({
      apiEndpoint: 'companies/:companyId/vendor-activity',
      options,
      pathParams,
      queryParams
    });
  }

  public async getVendorTradeCounts(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<CompanyVendorsTradeCountsResponseDto> {
    const { options, pathParams } = params;
    return await this.sendGet<CompanyVendorsTradeCountsResponseDto>({
      apiEndpoint: 'companies/:companyId/vendor-trade-counts',
      options,
      pathParams
    });
  }

  public async getExpiringInsurance(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
    queryParams?: { withinDays?: number };
  }): Promise<CompanyExpiringInsuranceResponseDto> {
    const { options, pathParams, queryParams } = params;
    return await this.sendGet<CompanyExpiringInsuranceResponseDto>({
      apiEndpoint: 'companies/:companyId/expiring-insurance',
      options,
      pathParams,
      queryParams
    });
  }

  public async getVendorSpotlightFromCompany(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
    queryParams?: { limit?: number; minReviews?: number };
  }): Promise<CompanyVendorsSpotlightResponseDto> {
    const { options, pathParams, queryParams } = params;
    return await this.sendGet<CompanyVendorsSpotlightResponseDto>({
      apiEndpoint: 'companies/:companyId/vendor-spotlight',
      options,
      pathParams,
      queryParams
    });
  }

  public async getContractsStatusCounts(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<ContractsSummaryResponseDto> {
    const { options, pathParams } = params;
    return await this.sendGet<ContractsSummaryResponseDto>({
      apiEndpoint: 'companies/:companyId/contracts/summary',
      options,
      pathParams
    });
  }
}

export const clientDashboardService = new ClientDashboardService();
